<div class="h-full overflow-auto">

  <!-- ============================================ -->
  <!-- VISTA: DETAIL - Timeline de grupos prioritarios -->
  <!-- ============================================ -->
  <div *ngIf="currentView === 'detail'" class="px-16 md:px-24 py-20 md:py-24 mx-auto max-w-[980px]">
    <div class="flex flex-col relative">
      <div class="w-full py-16 mb-16">
        <h2 class="font-sans text-h600 md:text-h800 text-center bg-gradient-2-text linear-gradient-2">
          {{ 'PRIORITY_TIMELINE.TITLE' | translate }}
        </h2>
        <p class="font-sans text-center text-gray-40 text-l">{{ 'PRIORITY_TIMELINE.LIST_1' | translate }} <span
            *ngIf="!hasVinculation">
            {{ 'PRIORITY_TIMELINE.LIST_2' | translate }}
          </span>
          <span *ngIf="hasVinculation">{{ 'PRIORITY_TIMELINE.HAS_VINCULATION_TEXT' | translate }}</span>
        </p>
      </div>
      <!-- Timeline Groups Loop -->
      <div *ngFor="let group of groupedPriorityGroups; let isLast = last; let i = index"
        class="relative pb-16 last:pb-0">

        <!-- Vertical Connector Line -->
        <div
          class="absolute left-[13px] top-[28px] bottom-0 w-[2px] bg-gradient-to-b from-eggplant-40 via-eggplant-25 to-transparent">
        </div>

        <!-- Priority Node & Items -->
        <div class="flex gap-10">

          <!-- Timeline Marker (Circle with Number) -->
          <div class="relative z-10 flex-shrink-0">
            <div
              class="flex items-center justify-center w-28 h-28 rounded-full bg-gradient-2 shadow-2xl ring-4 ring-cream-10 transition-all duration-300 absolute">
              <span class="text-m font-sansBold text-white leading-none">{{ group.priority }}</span>
            </div>
          </div>

          <!-- Group Content -->
          <div class="flex flex-col gap-16 w-full pb-16 pl-24">

            <!-- Individual Items within this Priority Group -->
            <div *ngFor="let pg of group.items"
              class="flex flex-col gap-8 rounded rounded-xl bg-gray-10/[0.1] p-24 p-12 md:p-16"
              [ngClass]="pg.isGroupObjetiveFull ? 'border-dashed border-eggplant-100/50 bg-eggplant-100/[0.04] ring-1 ring-eggplant-100/10' : 'border border-eggplant-100/[0.1] transition-all duration-300'">

              <!-- Item Main Header/Title -->
              <div class="flex flex-col gap-2">
                <div class="flex justify-between items-start gap-4">
                  <h3 class="text-xl font-sans"
                    [ngClass]="pg.isGroupObjetiveFull ? 'text-eggplant-100/80' : 'text-eggplant-100'">
                    {{ pg.name }}
                  </h3>

                  <div class="flex flex-col items-end gap-4">
                    <div *ngIf="pg.isEnabledForUser && pg.isGroupObjetiveFull"
                      class="flex gap-6 items-center mb-12 text-center w-fit px-8 rounded-lg pt-[3px] pb-2 bg-[#e0e3ff]">
                      <fun-icon [name]="'circle'" [style]="'w-12 h-12 fill-verified'"></fun-icon>
                      <p class="font-sans text-s md:text-m text-verified">{{ 'PRIORITY_TIMELINE.YOUR_GROUP_RESERVED' |
                        translate }}</p>
                    </div>
                    <div *ngIf="pg.isEnabledForUser && !pg.isGroupObjetiveFull && pg.priority === highestUserPriority"
                      class="flex gap-6 items-center mb-12 text-center w-fit px-8 rounded-lg pt-[3px] pb-2 bg-[#e0e3ff]">
                      <fun-icon [name]="'circle'" [style]="'w-12 h-12 fill-verified'"></fun-icon>
                      <p class="font-sans text-s md:text-m text-verified">{{ 'PRIORITY_TIMELINE.YOUR_GROUP' | translate
                        }}</p>
                    </div>
                    <div *ngIf="!pg.isEnabledForUser && pg.isGroupObjetiveFull"
                      class="flex gap-6 items-center mb-12 text-center w-fit px-8 rounded-lg pt-[3px] pb-2 bg-[#e0e3ff]">
                      <span class="font-sans text-s md:text-m text-verified">{{ 'PRIORITY_TIMELINE.OBJ_FULL' | translate
                        }}</span>
                    </div>
                  </div>
                </div>
                <p class="text-m font-sans leading-relaxed"
                  [ngClass]="pg.isGroupObjetiveFull ? 'text-eggplant-80' : 'text-eggplant-70'">
                  {{ pg.description }}
                </p>
                <div *ngIf="pg.isGroupObjetiveFull" class="mt-8 flex flex-col gap-6 w-full justify-center items-center">
                  <p
                    class="flex items-center px-10 py-6 rounded-xl bg-orange-100/15 text-orange-100 border border-orange-100/30 text-s font-sans uppercase whitespace-nowrap">
                    {{ 'PRIORITY_TIMELINE.INVESTMENT_NOT_AVAILABLE' | translate }}
                  </p>
                  <div class="flex items-center gap-4 rounded-lg bg-eggplant-100/[0.1] px-10 py-8">
                    <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-2 stroke-eggplant-100'"></fun-icon>
                    <p class="text-eggplant-80 text-s">
                      {{ 'PRIORITY_TIMELINE.OBJ_RESERVED_FULL' | translate }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Codes/Values Accordion -->
              <div *ngIf="pg.value && pg.type !== 2"
                class="rounded-l border border-eggplant-100/[0.08] overflow-hidden">
                <!-- Accordion Header -->
                <div (click)="toggleExpand(pg.id)"
                  class="flex items-center justify-between px-12 py-8 cursor-pointer bg-gray-10/[0.55] transition-colors duration-200">
                  <span class="text-s font-sansMedium text-eggplant-80">{{ 'PRIORITY_TIMELINE.VIEW_CODES' | translate
                    }}
                    ({{ parseValues(pg.value).length }})</span>
                  <fun-icon [name]="'chevron-down'"
                    [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100/[0.5] transition-transform duration-500 ' + (isExpanded(pg.id) ? 'rotate-180' : '')"></fun-icon>
                </div>
                <!-- Accordion Content -->
                <div *ngIf="isExpanded(pg.id)" class="px-12 pb-12 pt-6 bg-gray-10/[0.55]">
                  <div class="flex flex-col gap-10">
                    <div *ngFor="let group of groupByComunidad(pg.value)" class="flex flex-col gap-4">
                      <span class="text-s font-sansMedium text-eggplant-80 uppercase pt-6">{{ group.comunidad }}</span>
                      <div class="flex flex-wrap gap-2">
                        <span *ngFor="let code of group.codes"
                          class="px-6 pt-2 rounded-xl bg-white border border-eggplant-100/[0.1] text-s font-sans text-eggplant-80">
                          {{ code }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- CTAs para usuarios no vinculados -->
              <div *ngIf="!pg.isEnabledForUser && !pg.isGroupObjetiveFull"
                class="flex flex-col justify-center items-center">
                <p class="text-s font-sans text-eggplant-80">
                  {{ 'PRIORITY_TIMELINE.CAN_VINCULATE' | translate }}
                  <span *ngIf="pg.type === 1"> {{ 'PRIORITY_TIMELINE.OR_ADD_ADDRESS' | translate }} </span>
                </p>
                <div class="flex items-center gap-4 pt-6">
                  <fun-new-button *ngIf="pg.type === 2" size="s" icon="" iconPosition="" buttonType="primaryDark"
                    title="{{ 'PRIORITY_TIMELINE.ACCREDIT' | translate }}"
                    (eventClick)="sendVinculation(pg)"></fun-new-button>
                  <fun-new-button *ngIf="pg.type === 1" size="s" icon="" iconPosition="" buttonType="secondaryDark"
                    title="{{ 'PRIORITY_TIMELINE.ADD_ADDRESS' | translate }}"
                    (eventClick)="goToAddresses()"></fun-new-button>
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  </div>

  <!-- ============================================ -->
  <!-- VISTA: VINCULATE_LOADING - Procesando vinculación -->
  <!-- ============================================ -->
  <div *ngIf="currentView === 'vinculate_loading'" class="px-12 py-72">
    <div class="w-full py-32 flex flex-col relative items-center max-w-[620px] mx-auto gap-32">
      <fun-spinner></fun-spinner>
      <h2 class="font-sans text-h600 md:text-h800 text-center bg-gradient-2-text linear-gradient-2">{{
        'PRIORITY_TIMELINE.VINCULATING_1' | translate }}
      </h2>
      <p class="font-sans text-center text-gray-40 text-l">{{ 'PRIORITY_TIMELINE.VINCULATING_2' | translate }}</p>
    </div>
  </div>

  <!-- ============================================ -->
  <!-- VISTA: VINCULATE_SUCCESS - Éxito vinculación -->
  <!-- ============================================ -->
  <div *ngIf="currentView === 'vinculate_success'" class="px-12 py-72">
    <div class="w-full py-32 flex flex-col relative items-center max-w-[620px] mx-auto gap-32">
      <fun-icon [name]="'check-circle'" [style]="'w-48 h-48 stroke-[4px] stroke-orange-100'"></fun-icon>
      <h2 class="font-sans text-h600 md:text-h800 text-center bg-gradient-2-text linear-gradient-2">{{
        'PRIORITY_TIMELINE.VINCULATING_3' | translate }}
      </h2>
      <p class="font-sans text-center text-gray-40 text-l pb-24">{{ 'PRIORITY_TIMELINE.VINCULATING_4' | translate }}</p>
      <fun-new-button size="l" (eventClick)="closeModal()" [buttonType]="'primaryDark'" title="{{ 'COMMON.ACCEPT' | translate }}"
        [classExtra]="' !w-full max-w-[300px] '"></fun-new-button>
    </div>
  </div>

  <!-- ============================================ -->
  <!-- VISTA: VINCULATE_ERROR - Error vinculación -->
  <!-- ============================================ -->
  <div *ngIf="currentView === 'vinculate_error'" class="px-12 py-72">
    <div class="w-full py-32 flex flex-col relative items-center max-w-[620px] mx-auto gap-32">
      <fun-icon [name]="'user-x'" [style]="'w-48 h-48 stroke-[4px] stroke-orange-100'"></fun-icon>
      <h2 class="font-sans text-h600 md:text-h800 text-center bg-gradient-2-text linear-gradient-2">{{
        'PRIORITY_TIMELINE.ERROR_1' | translate }}
      </h2>
      <p class="font-sans text-center text-gray-40 text-l pb-24">{{ 'PRIORITY_TIMELINE.ERROR_2' | translate }}</p>
      <div class="flex gap-16">
        <fun-new-button size="l" (eventClick)="goBack()" [buttonType]="'secondaryDark'" title="{{ 'COMMON.BACK' | translate }}"
          [classExtra]="' '"></fun-new-button>
        <fun-new-button size="l" (eventClick)="retryVinculation()" [buttonType]="'primaryDark'" title="{{ 'COMMON.RETRY' | translate }}"
          [classExtra]="' '"></fun-new-button>
      </div>
    </div>
  </div>

  <!-- ============================================ -->
  <!-- VISTA: ADDRESSES - Reutiliza fun-profile-addresses -->
  <!-- ============================================ -->
  <div *ngIf="currentView === 'addresses'" class="px-12 py-16">

    <!-- Header -->
    <div class="w-full py-16 mb-16">
      <h2 class="font-sans text-h600 md:text-h800 text-center bg-gradient-2-text linear-gradient-2">{{
        'PRIORITY_TIMELINE.MY_ADDRESSES' | translate }}</h2>
      <p class="font-sans text-center text-gray-40 text-l">{{ 'PRIORITY_TIMELINE.CHECK_MY_ADDRESSES' | translate }}</p>
    </div>

    <!-- Loading state -->
    <div *ngIf="addressesLoading" class="flex justify-center py-32">
      <fun-spinner></fun-spinner>
    </div>

    <!-- Reutilizamos el componente de direcciones en modo embebido -->
    <div *ngIf="!addressesLoading">
      <fun-profile-addresses [profile]="profile" [addresses]="addresses" [embeddedMode]="true"
        (addAddressEvent)="onAddAddressFromList()" (editAddressEvent)="onEditAddressFromList($event)"
        (addressSaved)="onAddressSaved($event)">
      </fun-profile-addresses>

      <!-- Footer direcciones -->
      <div class="button-container flex py-24 justify-start mx-auto max-w-[980px]">
        <fun-new-button size="l" (eventClick)="goBack()" icon="arrow-left" [iconPosition]="'left'"
          [buttonType]="'ghost'" title="{{ 'local_invest.go_back' | translate }}" [responsive]="false"></fun-new-button>
      </div>
    </div>
  </div>

  <!-- ============================================ -->
  <!-- VISTA: ADDRESS_FORM - Reutiliza fun-profile-address-form -->
  <!-- ============================================ -->
  <div *ngIf="currentView === 'address_form'" class="h-full">
    <fun-profile-address-form [profile]="profile" [address]="editingAddress" [isEdit]="isEditAddress"
      (saveEvent)="onSaveAddress($event)" (cancelEvent)="onCancelAddressForm()">
    </fun-profile-address-form>
  </div>

</div>